import React, {useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {Card, Carousel, Col, Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'>
                  {' '}
                  Respiratory viruses - Positivity rate among samples tested (Germany){' '}
                  <OverlayTrigger
                    placement='right'
                    overlay={
                      <Tooltip id='logo-tooltip' style={{width: '300px'}}>
                        <p>
                          The indicator is calculated weekly based on the percentage between all
                          positive respiratory viruses that have been identified and all sentinel
                          samples submitted that were tested, using the data of the weekly Reports
                          of the AGI (Arbeitgemeinschaft Influenza) uploaded on
                          https://influenza.rki.de/Wochenberichte.aspx
                        </p>
                      </Tooltip>
                    }
                  >
                    <img
                      style={{width: '12px', marginLeft: '10px'}}
                      alt='logo'
                      src={toAbsoluteUrl('/media/logos/ii.svg')}
                    />
                  </OverlayTrigger>
                  {/* <i
                    style={{color: 'green', marginLeft: '10%', fontSize: '20px'}}
                    className='  fa-solid fa-arrow-down '
                  ></i> */}
                </h2>
              </div>
              <Card.Body className='row' style={{marginTop: '-35px'}}>
                <StreamgraphChart />
                <p className='card-text source mt-2'>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://www.rki.de/en'>
                      {' '}
                      Robert Koch-Institut
                    </a>
                  </i>{' '}
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const Influenza = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export {Influenza}
